// @flow

import React from 'react'

/**
  * @func time
  * @param {number} seconds
  * @returns {number}
*/
export function time (seconds) {
  const hours = Math.floor(seconds / (60 * 60))
  const minutes = Math.floor(seconds / 60) % 60
  const remaining = (seconds % 60).toFixed(0)
  if (hours >= 1) {
    return <span>{hours}<span className='unit'>h</span> {minutes}<span className='unit'>m</span></span>
  } else if (minutes >= 1) {
    return <span>{minutes}<span className='unit'>m</span>  {remaining}<span className='unit'>s</span></span>
  } else {
    return <span>{remaining}<span className='unit'>s</span></span>
  }
}

/**
  * @func dateTime
  * @param {number} datestamp
  * @returns {string}
*/
export function dateTime (datestamp) {
  if (datestamp) {
    const day = new Date(datestamp)
    return `${day.toDateString()} at ${day.toLocaleTimeString()}`
  } else {
    return '--'
  }
}

/**
  * @func numberedDate
  * @param {number} datestamp
  * @returns {string}
*/
export function numberedDate (datestamp) {
  if (datestamp) {
    const day = new Date(datestamp)
    return `${day.toLocaleDateString()} at ${day.toLocaleTimeString()}`
  } else {
    return 0
  }
}

/**
  * @func numberedDateLined
  * @param {number} datestamp
  * @returns {string}
*/
export function numberedDateLined (datestamp) {
  if (datestamp) {
    const day = new Date(datestamp)
    return `${day.toLocaleDateString()} | ${day.toLocaleTimeString()}`
  } else {
    return 0
  }
}

/**
  * @func justDate
  * @param {number} datestamp
  * @returns {string}
*/
export function justDate (datestamp) {
  if (datestamp) {
    const day = new Date(datestamp)
    return `${day.toDateString()}`
  } else {
    return 0
  }
}

/**
  * @func processDateRange
  * @param {number} dateRange
  * @returns {Object}
*/
export function processDateRange (dateRange) {
  const dates = dateRange.split('_')
  return {
    start: dates[0],
    end: dates[1]
  }
}

/**
 * @func processDateRange
 * @param {number} dateRange
 * @returns {Object}
 */
export function processStringToDate (dateRange) {
  const dates = dateRange.split('_')
  return {
    start: new Date(dates[0] + 'T00:00:00'),
    end: new Date(dates[1] + 'T00:00:00')
  }
}

/**
  * @func saveDateRange
  * @param {number} dateRange
  * @returns {string}
*/
export function saveDateRange (dateRange) {
  return `${dateRange.start}_${dateRange.end}`
}

/**
  * @func dateDelta
  * @param {number} dateSetting
  * @returns {string}
*/
export function dateDelta (dateSetting) {
  switch (dateSetting) {
    case 'Day':
      return 'since yesterday'
    case 'Week':
      return 'since last week'
    case 'Month':
      return 'since last month'
    default:
      return 'over custom timeframe'
  }
}

/**
 * format date to YYYY-mm-dd
 * @param {Date} date
 * @returns {string}
 */
export function formatDateYMD (date) {
  let month = '' + (date.getMonth() + 1)
  let day = '' + date.getDate()
  const year = date.getFullYear()

  if (month.length < 2) {
    month = '0' + month
  }
  if (day.length < 2) {
    day = '0' + day
  }

  return [year, month, day].join('-')
}

/**
 * @func localeDateTimeString
 * @param {number} datestamp
 * @returns {string} of this format March 15, 2021 at 5:25 pm
 */
export function localeDateTimeString (datestamp) {
  if (datestamp) {
    const day = new Date(datestamp)
    const monthName = day.toLocaleString({}, { month: 'long' })
    const hourMin = day.toLocaleTimeString({}, { hour: '2-digit', minute: '2-digit', timeZoneName: 'short' })
    return `${monthName} ${day.getDate()}, ${day.getFullYear()} at ${hourMin}`
  } else {
    return '--'
  }
}
